import { batch } from '@tmapy/redux';
import { EDIT_TOOLS } from '@tmapy/config';
import { GEOMETRY_TYPE, INTERACTION, MAP_TOOL, LAYER_IDS, OPERATION_METHOD } from '@tmapy/config';
import { actionSetInteraction, actionSetLayerStyle } from '@tmapy/mapcore';
import { actionSetMapTool } from '@tmapy/ui-manager';
import { ACTIVATE_INTERSECTION_SPLIT_LINE_TOOL, ACTIVATE_JOIN_LINE_TOOL, UPDATE_JOIN_LINE_TOOL, UPDATE_LOADED_FEATURES, UPDATE_SELECT_FEATURE_TOOL, } from '../constants';
import { actionDeactivateTools } from './deactivateTool';
// ---
const ACTION_INTERACTION_DELETE = {
    type: INTERACTION.NONE,
    layerId: LAYER_IDS.EDIT_TOOLS_MODIFY,
    style: 'ACTIVE',
    highlightedFeaturesCount: 1,
    originLayerId: null,
    operationMethod: OPERATION_METHOD.DELETE,
};
export const actionActivateDeleteTool = () => (dispatch) => {
    batch('actionActivateDeleteTool', () => {
        dispatch(actionDeactivateTools());
        dispatch(actionSetMapTool(MAP_TOOL.DELETE));
        dispatch(actionSetInteraction(ACTION_INTERACTION_DELETE));
    });
};
const ACTION_INTERACTION_MODIFY = {
    type: INTERACTION.MODIFY,
    layerId: LAYER_IDS.EDIT_TOOLS_MODIFY,
    style: 'ACTIVE',
    highlightedFeaturesCount: 1,
    originLayerId: null,
};
export const actionActivateEditTools = () => (dispatch, getState) => {
    const state = getState();
    const activeMapTool = state.uiManager.activeMapTool;
    if (!EDIT_TOOLS.includes(activeMapTool)) {
        dispatch(actionActivateEditTool());
    }
};
const ACTION_INTERACTION_DRAW = {
    type: INTERACTION.DRAW,
    layerId: LAYER_IDS.EDIT_TOOLS_MODIFY,
    style: 'ACTIVE',
    highlightedFeaturesCount: 0,
    originLayerId: null,
};
/**
 * Action called by UI icon
 */
export const actionActivateEditTool = (mapTool = MAP_TOOL.INFOEDIT, drawGeometryType = 'Point') => (dispatch) => {
    batch('actionActivateEditTool', () => {
        dispatch(actionDeactivateTools());
        dispatch(actionSetMapTool(mapTool));
        dispatch(actionSetInteraction([MAP_TOOL.INFOEDIT, MAP_TOOL.SELECT_FEATURE].includes(mapTool)
            ? ACTION_INTERACTION_MODIFY
            : { ...ACTION_INTERACTION_DRAW, drawGeometryType }));
    });
};
const ACTION_INTERACTION_REVERSE_LINE_TOOL = {
    type: INTERACTION.NONE,
    layerId: LAYER_IDS.EDIT_TOOLS_MODIFY,
    style: 'ACTIVE',
    highlightedFeaturesCount: 1,
    geometryTypeFilter: [
        GEOMETRY_TYPE.LINE_STRING,
        GEOMETRY_TYPE.MULTI_LINE_STRING,
    ],
    originLayerId: null,
    operationMethod: OPERATION_METHOD.UPDATE,
};
/**
 * Action called by UI icon
 */
export const actionActivateReverseLineTool = () => (dispatch) => {
    batch('actionActivateReverseLineTool', () => {
        dispatch(actionDeactivateTools());
        dispatch(actionSetMapTool(MAP_TOOL.REVERSE_LINE));
        dispatch(actionSetInteraction(ACTION_INTERACTION_REVERSE_LINE_TOOL));
        dispatch(actionSetLayerStyle(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, 'DEFAULT', 'ARROW.highlight'));
    });
};
export const actionUpdateJoinLineTool = (payload) => ({
    type: UPDATE_JOIN_LINE_TOOL,
    payload,
});
export const actionUpdateSelectFeatureTool = (payload) => ({
    type: UPDATE_SELECT_FEATURE_TOOL,
    payload,
});
export const actionUpdateLoadedFeatures = (payload) => ({
    type: UPDATE_LOADED_FEATURES,
    payload,
});
const ACTION_INTERACTION_SELECT = {
    type: INTERACTION.SELECT,
    layerId: LAYER_IDS.EDIT_TOOLS_MODIFY,
    style: 'ACTIVE',
    highlightedFeaturesCount: 1,
    geometryTypeFilter: [
        GEOMETRY_TYPE.LINE_STRING,
        GEOMETRY_TYPE.MULTI_LINE_STRING,
    ],
    originLayerId: null,
};
export const actionActivateJoinLineTool = () => (dispatch) => {
    batch('actionActivateJoinLineTool', () => {
        dispatch(actionDeactivateTools());
        dispatch(actionSetMapTool(MAP_TOOL.JOIN_LINE));
        dispatch(actionSetInteraction(ACTION_INTERACTION_SELECT));
        dispatch(actionSetLayerStyle(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, 'ACTIVE', 'HIGHLIGHT'));
        dispatch({
            type: ACTIVATE_JOIN_LINE_TOOL,
            payload: null,
        });
    });
};
const ACTION_INTERACTION_INTERSECTION_SPLIT_LINE_TOOL = {
    type: INTERACTION.NONE,
    layerId: LAYER_IDS.EDIT_TOOLS_MODIFY,
    style: 'DEFAULT',
    highlightedFeaturesCount: 2,
    geometryTypeFilter: [
        GEOMETRY_TYPE.LINE_STRING,
        GEOMETRY_TYPE.MULTI_LINE_STRING,
    ],
    originLayerId: null,
    operationMethod: OPERATION_METHOD.UPDATE,
};
export const actionActivateIntersectionSplitLineTool = () => (dispatch) => {
    batch('actionActivateIntersectionSplitLineTool', () => {
        dispatch(actionDeactivateTools());
        dispatch(actionSetMapTool(MAP_TOOL.INTERSECTION_SPLIT_LINE));
        dispatch(actionSetInteraction(ACTION_INTERACTION_INTERSECTION_SPLIT_LINE_TOOL));
        dispatch(actionSetLayerStyle(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, 'DEFAULT', 'HIGHLIGHT'));
        dispatch({
            type: ACTIVATE_INTERSECTION_SPLIT_LINE_TOOL,
            payload: null,
        });
    });
};
const ACTION_INTERACTION_SPLIT_LINE_TOOL = {
    type: INTERACTION.NONE,
    layerId: LAYER_IDS.EDIT_TOOLS_MODIFY,
    style: 'DEFAULT',
    highlightedFeaturesCount: 1,
    geometryTypeFilter: [
        GEOMETRY_TYPE.LINE_STRING,
        GEOMETRY_TYPE.MULTI_LINE_STRING,
    ],
    originLayerId: null,
    operationMethod: OPERATION_METHOD.UPDATE,
};
export const actionActivateSplitLineTool = () => (dispatch) => {
    batch('actionActivateSplitLineTool', () => {
        dispatch(actionDeactivateTools());
        dispatch(actionSetMapTool(MAP_TOOL.SPLIT_LINE));
        dispatch(actionSetInteraction(ACTION_INTERACTION_SPLIT_LINE_TOOL));
        dispatch(actionSetLayerStyle(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, 'DEFAULT', 'HIGHLIGHT'));
    });
};
export const actionActivateSelectFeatureTool = () => (dispatch) => {
    dispatch(actionDeactivateTools());
    dispatch(actionUpdateSelectFeatureTool({ selectedFeatureData: null, selectedFeature: null }));
    dispatch(actionSetMapTool(MAP_TOOL.SELECT_FEATURE));
};
//# sourceMappingURL=components.js.map